/* SET STATE */
export const SET_STATE_DEFAULT_ASSIGNMENT = "SET_STATE_DEFAULT_ASSIGNMENT"

/* DEFAULT_ASSIGNMENTS */
export const GET_DEFAULT_ASSIGNMENTS = "GET_DEFAULT_ASSIGNMENTS"
export const GET_DEFAULT_ASSIGNMENTS_SUCCESS = "GET_DEFAULT_ASSIGNMENTS_SUCCESS"
export const GET_DEFAULT_ASSIGNMENTS_FAIL = "GET_DEFAULT_ASSIGNMENTS_FAIL"

/* DEFAULT_ASSIGNMENT */
export const GET_DEFAULT_ASSIGNMENT = "GET_DEFAULT_ASSIGNMENT"
export const GET_DEFAULT_ASSIGNMENT_SUCCESS = "GET_DEFAULT_ASSIGNMENT_SUCCESS"
export const GET_DEFAULT_ASSIGNMENT_FAIL = "GET_DEFAULT_ASSIGNMENT_FAIL"

/**
 * ADD DEFAULT_ASSIGNMENT
 */
export const ADD_NEW_DEFAULT_ASSIGNMENT = "ADD_NEW_DEFAULT_ASSIGNMENT"
export const ADD_DEFAULT_ASSIGNMENT_SUCCESS = "ADD_DEFAULT_ASSIGNMENT_SUCCESS"
export const ADD_DEFAULT_ASSIGNMENT_FAIL = "ADD_DEFAULT_ASSIGNMENT_FAIL"

 /**
 * UPDATE DEFAULT_ASSIGNMENT
 */
export const UPDATE_DEFAULT_ASSIGNMENT = "UPDATE_DEFAULT_ASSIGNMENT"
export const UPDATE_DEFAULT_ASSIGNMENT_STATUS = "UPDATE_DEFAULT_ASSIGNMENT_STATUS"
export const UPDATE_DEFAULT_ASSIGNMENT_SUCCESS = "UPDATE_DEFAULT_ASSIGNMENT_SUCCESS"
export const UPDATE_DEFAULT_ASSIGNMENT_FAIL = "UPDATE_DEFAULT_ASSIGNMENT_FAIL"

/**
 * DELETE DEFAULT_ASSIGNMENT
 */
export const DELETE_DEFAULT_ASSIGNMENT = "DELETE_DEFAULT_ASSIGNMENT"
export const DELETE_DEFAULT_ASSIGNMENT_SUCCESS = "DELETE_DEFAULT_ASSIGNMENT_SUCCESS"
export const DELETE_DEFAULT_ASSIGNMENT_FAIL = "DELETE_DEFAULT_ASSIGNMENT_FAIL"
